export default {
  AccountCenterHome: 'Account Center',
  AccountCenterPassword: 'Change Password',
  OnlineOperation: 'Online Operations',
  Advert: 'Advertisement Management',
  AdvertEdit: 'Advertisement Settings',
  Decorate: 'Decoration Management',
  DecorateAdd: 'Decoration Template Settings',
  MiniProgramManage: 'Mini Program Management',
  Template: 'Template Library',
  ChannelManage: 'Channel Management',
  ProjectDeduction: 'Device Operations',
  DeviceManage: 'Device Management',
  DeviceAuthorization: 'Device Authorization',
  // Operation tools (backend menus: device operations/operation tools/device activation)
  OperationTools: 'Operation Tools',
  DeviceActivation: 'Device Activation',
  // Cashier device (backend menu: device operations/device management/cashier device)
  CashierDevice: 'Cashier Device',
  // Fee center (backend menus: feeCenter/service, feeCenter/order; dynamic route name = capitalized path)
  FeeCenter: 'Fee Center',
  FeeCenterService: 'Value-added Services',
  FeeCenterOrder: 'Order Management',
  Service: 'Value-added Services',
  Order: 'Order Management',
  FeeCenterOrderConfirm: 'Confirm Order',
  FeeCenterPayment: 'Order Payment',
};
